import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "パスワードをリセットするためのメールを送信します。", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "パスワードリセットメールを送信しました。メールを確認してください。", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.$style.parent
  }, [
    (!_ctx.state.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_form_item, { label: "メールアドレス" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.email) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            color: _ctx.BUTTON_COLOR,
            round: true,
            onClick: _ctx.submit
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_icon, { class: "is-loading" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Loading)
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.state.sending]
              ]),
              _createTextVNode(" 送信 ")
            ]),
            _: 1
          }, 8, ["color", "onClick"]),
          _createElementVNode("p", null, [
            _createTextVNode(" メールアドレスが不明の方はお手数ですが "),
            _createVNode(_component_router_link, { to: "/user/create" }, {
              default: _withCtx(() => [
                _createTextVNode("新しいアカウントを作成")
              ]),
              _: 1
            }),
            _createTextVNode(" してください ")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}